(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["windsor-purchase"] && !Shopify.designMode) return;
  try {
    function initialiseElliotsPurchase(scope = document) {
    scope.querySelectorAll('[data-elliots-purchase]').forEach(root => {
      if (root.dataset.initialised) return;
      const section = root.closest('[data-section-type="product"]');
      const form = root.closest('form');
      const priceSource = form?.querySelector('.elliots-price-source .price-list');
      const buttons = form?.querySelector('.product-form__payment-container');
      if (!section || !form || !priceSource || !buttons) return;
      root.dataset.initialised = 'true';
      form.classList.add('elliots-product-form');
      document.body.classList.add('elliots-product-page');
      const formatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: root.dataset.currency || 'GBP' });
      const money = cents => formatter.format(cents / 100);
      const parsePrice = node => {
        if (!node) return null;
        const value = Number(node.textContent.replace(/[^0-9.]/g, ''));
        return Number.isFinite(value) && value > 0 ? Math.round(value * 100) : null;
      };
      const updatePrice = () => {
        const quantity = Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1);
        const multiplier = form.querySelector('.mw-apo-add-to-cart-cloned') ? 1 : quantity;
        const cents = (parsePrice(priceSource.querySelector('.price:not(.price--compare)')) || Number(root.dataset.initialPrice)) * multiplier;
        root.querySelector('[data-purchase-total]').textContent = money(cents);
        const comparison = (parsePrice(priceSource.querySelector('.price--compare')) || 0) * multiplier;
        const compareOutput = root.querySelector('[data-purchase-compare]');
        compareOutput.hidden = !comparison || comparison <= cents;
        if (comparison) compareOutput.textContent = money(comparison);
        const saving = Math.max(0, comparison - cents);
        root.querySelector('[data-purchase-savings]').hidden = saving <= 0;
        root.querySelector('[data-saved-amount]').textContent = money(saving);
        root.querySelector('[data-klarna-payment]').textContent = money(Math.ceil(cents / 3));
        root.querySelector('[data-clearpay-payment]').textContent = money(Math.ceil(cents / 4));
        root.querySelector('[data-clearpay-eligible]').hidden = cents > 120000;
        root.querySelector('[data-clearpay-limit]').hidden = cents <= 120000;
      };
      const observer = new MutationObserver(updatePrice);
      observer.observe(priceSource, { childList: true, characterData: true, subtree: true });
      updatePrice();
      const quantity = form.querySelector('[name="quantity"]');
      form.addEventListener('click', event => {
        if (!event.target.closest('[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"]')) return;
        queueMicrotask(() => { quantity?.dispatchEvent(new Event('change', { bubbles: true })); updatePrice(); });
      });
      quantity?.addEventListener('change', updatePrice);
      quantity?.addEventListener('input', () => {
        const value = Number(quantity.value);
        if (Number.isInteger(value) && value > 0) quantity.dispatchEvent(new Event('change', { bubbles: true }));
      });
      const template = root.querySelector('[data-buy-now-template]');
      if (template) buttons.append(template.content.cloneNode(true));
      const syncAvailability = () => {
        const buyNow = form.querySelector('[data-elliots-buy-now]');
        if (!buyNow || buyNow.getAttribute('aria-busy') === 'true') return;
        const add = form.querySelector('.mw-apo-add-to-cart-cloned') || form.querySelector('[data-action="add-to-cart"]');
        const disabled = !add || add.disabled;
        if (buyNow.disabled !== disabled) buyNow.disabled = disabled;
      };
      new MutationObserver(syncAvailability).observe(buttons, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
      syncAvailability();
    });
  }
  let elliotsPendingCheckout = null;
  document.addEventListener('click', event => {
    const buyNow = event.target.closest('[data-elliots-buy-now]');
    if (!buyNow) return;
    const form = buyNow.closest('form');
    if (!form?.querySelector('[data-elliots-purchase]')) return;
    event.preventDefault();
    event.stopPropagation();
    if (elliotsPendingCheckout) return;
    const add = form.querySelector('.mw-apo-add-to-cart-cloned') || form.querySelector('[data-action="add-to-cart"]');
    if (!add || add.disabled) return;
    const error = form.querySelector('[data-buy-now-error]');
    error.hidden = true;
    buyNow.disabled = true;
    buyNow.setAttribute('aria-busy', 'true');
    const pending = { form, buyNow, timer: null };
    elliotsPendingCheckout = pending;
    pending.timer = setTimeout(() => {
      if (elliotsPendingCheckout !== pending) return;
      elliotsPendingCheckout = null;
      buyNow.disabled = false;
      buyNow.removeAttribute('aria-busy');
      error.hidden = false;
    }, 30000);
    add.click();
  }, true);
  document.addEventListener('product:added', event => {
    const pending = elliotsPendingCheckout;
    if (!pending) return;
    const section = pending.form.closest('[data-section-type="product"]');
    if (event.target !== document.documentElement && event.target !== document && !section?.contains(event.target)) return;
    clearTimeout(pending.timer);
    const path = window.Shopify?.routes?.root || '/';
    window.location.assign(path + 'checkout');
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseElliotsPurchase());
  else initialiseElliotsPurchase();
  document.addEventListener('shopify:section:load', event => initialiseElliotsPurchase(event.target));
  } catch(e) { console.error(e); }
})();

})();
